import { render } from "./IconWarning.vue?vue&type=template&id=b117ec86"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconWarning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b117ec86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b117ec86', __exports__)) {
    api.reload('b117ec86', __exports__)
  }
  
  module.hot.accept("./IconWarning.vue?vue&type=template&id=b117ec86", () => {
    api.rerender('b117ec86', render)
  })

}


export default __exports__